<template>
    <div class="modal" id="roomSettingModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">객실 설정</h4>
                    <button type="button" class="btn btn-m flat btn-close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="text-center mt-40">
                        <b>객실 상태정보를 변경합니다.</b>
                    </p>
                    <p class="text-center text-666 mt-10">
                        객실 관리를 위해 설정된 기간 동안 객실 예약을 금지합니다.
                        <br>사용 불가 객실 취소는 캘린더에서 가능합니다.
                    </p>
                    <div class="box mt-30">
                        <div class="box-header text-right text-888 pv-6">(
                            <span class="ess ex"></span>필수 입력 사항입니다.)</div>
                        <div class="box-body">
                            <form action="">
                                <div class="form-group row">
                                    <label class="form-control-label col-4">
                                        <span>객실 선택</span>
                                    </label>
                                    <div class="col-8">
                                        <dropdown v-model="selectedRoomId" :datasource="rooms" displayName="dropdownName"
                                                  valueName="roomId" placeholder="IDC 권한 " :isAuto="true" :isSelectedIcon="true"/>
<!--                                        <div class="dropdown inline">-->
<!--&lt;!&ndash;                                            <button class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{selectedSettingRoom.roomNumber}} / {{selectedSettingRoom.roomType.roomType}}</button>&ndash;&gt;-->
<!--                                            <button class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{selectedSettingRoom.roomNumber}} / {{selectedSettingRoom.roomType.roomType}}</button>-->
<!--                                            <div class="dropdown-menu dropdown-menu-scale">-->
<!--                                                <a v-for="(room, index) in rooms" class="dropdown-item selected">{{room.roomNumber}} / {{room.roomType.roomType}}</a>-->
<!--                                                <a class="dropdown-item">메뉴2</a>-->
<!--                                                <a class="dropdown-item" disabled="">메뉴3</a>-->
<!--                                            </div>-->
<!--                                        </div>-->
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="form-control-label col-4">
                                        <span class="ess">사용 불가 시작일</span>
                                    </label>
                                    <div class="col-4">
                                        <!--                      <input type="text" class="form-control" placeholder="최소 3글자, 최대 30자">-->
                                        <DatePicker class="form-control"
                                                    default-panel="date"
                                                    :append-to-body="false"
                                                    :popup-style="{ left: 0}"
                                                    :clearable="false"
                                                    :editable="true"
                                                    style="font-size: 12px;"
                                                    input-class="calendar-input"
                                                    v-model="unavailableFrom"
                                        >
                                            <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                                        </DatePicker>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="form-control-label col-4">
                                        <span class="ess">사용 불가 종료일</span>
                                    </label>
                                    <div class="col-4">
                                        <!--                      <input type="text" class="form-control" placeholder="최소 3글자, 최대 30자">-->
                                        <DatePicker class="form-control"
                                                    default-panel="date"
                                                    :append-to-body="false"
                                                    :popup-style="{ left: 0}"
                                                    :clearable="false"
                                                    :editable="true"
                                                    style="font-size: 12px;"
                                                    input-class="calendar-input"
                                                    v-model="unavailableTo"
                                        >
                                            <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                                        </DatePicker>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="form-control-label col-4">
                                        <span>메모</span>
                                    </label>
                                    <div class="col-8">
                                        <textarea class="form-control" placeholder="텍스트를 입력하세요" v-model="description"></textarea>
<!--                                        <div class="mt-5">-->
<!--                                            <span class="text-danger">1000 bytes 이상일 때 경고 메세지</span>-->
<!--                                            <span class="pull-right">-->
<!--                                            <span class="text-danger">1002</span>/1000 bytes</span>-->
<!--                                        </div>-->
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="btn-wrap justify-content-center mt-30 mb-40">
                        <button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close">
                            <i class="icon-close mr-5"></i>취소</button>
                        <button class="btn btn-lg success" data-dismiss="modal" aria-label="Close" @click="submit()">
                            <i class="icon-check mr-5"></i>적용</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Dropdown from '@/components/Dropdown.vue';

    export default {
        components: {Dropdown},
        name: "RoomSettingModal",
        props: ['selectedSettingRoom', 'rooms'],
        data() {
            return {
                unavailableFrom: moment(new Date()).startOf('day').toDate(),
                unavailableTo: moment(new Date()).startOf('day').toDate(),
                selectedRoomId: null,
                description: null
            }
        },
        watch: {
            selectedSettingRoom: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.selectedRoomId = newVal.roomId;
                }
            },
        },
        mounted(){

        },
        methods: {
            submit() {
                let param = {
                    roomId: this.selectedRoomId,
                    fromDate: this.unavailableFrom.getTime(),
                    toDate: this.unavailableTo.getTime(),
                    description: this.description
                };

                this.$http.post('/api/private/booking/unAvailableRoom', param)
                    .then((result) => {
                        this.noti('완료', '사용 불가 객실 지정을 완료하였습니다.', 'success');
                        this.$emit('init');
                    }).catch((e) =>{
                        this.noti('완료', '사용 불가 객실 지정에 실패하였습니다..', 'warning');
                        console.log(e);
                    })
            }
        }
    }
</script>

<style scoped>

</style>